import type { Update } from '@baseball-near-you/prisma';
import { toast } from '@baseball-near-you/ui';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { clients } from '../clients';
import { QueryKey } from '../hooks/QueryKey';

export function useTeamBulletinMutation(args: {
  teamId: number;
}) {
  const { teamId } = args ?? {};
  const queryClient = useQueryClient();
  const { mutateAsync: addBulletin, isLoading: addingBulletin } = useMutation({
    mutationFn: (bulletin: Partial<Update>) => {
      return clients.team.addBulletin({
        args: { teamId },
        payload: bulletin,
      });
    },
    onSuccess: async (bulletin) => {
      await queryClient.refetchQueries([
        QueryKey.Team,
        bulletin.teamId,
        'bulletins',
      ]);

      toast.success('Post saved', {
        description: 'Your post has been saved to your team successfully',
      });
    },
    onError: (error: { message?: string }) => {
      toast.error('There was an saving adding your post.', {
        description: error?.message ?? 'Please try again later',
      });
    },
  });

  const { mutateAsync: deleteBulletin, isLoading: deletingBulletin } =
    useMutation({
      mutationFn: (bulletinId: number) => {
        if (!teamId) {
          throw new Error('Team not found');
        }

        return clients.team.deleteBulletin({
          args: { teamId: teamId, bulletinId },
        });
      },
      onSuccess: async () => {
        await queryClient.refetchQueries([QueryKey.Team, teamId]);
      },
    });
  return {
    addBulletin,
    addingBulletin,
    deleteBulletin,
    deletingBulletin,
  };
}
